export enum InvoiceSubCriterias {
  INVOICE_NUMBER = "Invoice Number",
  CASE_NUMBER = "Case Number",
  DEBTOR_NAME = "Debtor Name",
  DEBTOR_NUMBER = "Debtor Number",
  KID = "KID",
}
